module.exports = __webpack_public_path__ + "fonts/593cdea.otf";